// extracted by mini-css-extract-plugin
module.exports = {"text":"StateSkeleton_text__3kUjm","container":"StateSkeleton_container__2goLq"};